import {
  SET_BLOGS,
  SET_RB_BLOGS,
  FETCH_BLOG_LOADING,
  SET_BLOG_FILTER,
  SET_GALLERY_MEDIA,
  SET_GALLERY_TOTAL_PAGES,
  BLOG_TOTAL_PAGES,
  NEW_BLOG,
  LOADING_GET_BLOG_ITEMS,
  CLEAR_RB_BLOGS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  allBlogs: [],
  allrbBlogs: [],
  gallery: [],
  fetchBlogsLoading: false,
  bLogFilter: "",
  galleryTotalPages: 0,
  blogTotalPages: 0,
  newBlog: false,
  loadingBlogData: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_BLOGS: {
      const existingIds = new Set(state.allBlogs.map((item) => item._id));
      const newItems = action.payload.filter(
        (item) => !existingIds.has(item._id)
      );
      return { ...state, allBlogs: [...state.allBlogs, ...newItems] };
    }
    case SET_RB_BLOGS: {
      const existingIds = new Set(state.allrbBlogs.map((item) => item._id));
      const newItems = action.payload.filter(
        (item) => !existingIds.has(item._id)
      );
      return { ...state, allrbBlogs: [...state.allrbBlogs, ...newItems] };
    }
    case CLEAR_RB_BLOGS: {
      return { ...state, allrbBlogs: [] };
    }
    case FETCH_BLOG_LOADING: {
      return { ...state, fetchBlogsLoading: action.payload };
    }
    case SET_BLOG_FILTER: {
      return { ...state, bLogFilter: action.payload, allBlogs: [] };
    }
    case SET_GALLERY_MEDIA: {
      const existingIds = new Set(state.gallery.map((item) => item._id));
      const newItems = action.payload.filter(
        (item) => !existingIds.has(item._id)
      );
      return { ...state, gallery: [...state.gallery, ...newItems] };
    }
    case BLOG_TOTAL_PAGES: {
      return { ...state, blogTotalPages: action.payload };
    }
    case SET_GALLERY_TOTAL_PAGES: {
      return { ...state, galleryTotalPages: action.payload };
    }
    case NEW_BLOG: {
      return { ...state, newBlog: action.payload };
    }
    case LOADING_GET_BLOG_ITEMS: {
      return { ...state, loadingBlogData: action.payload };
    }
    default:
      return state;
  }
};
